// extracted by mini-css-extract-plugin
module.exports = {"lottieContainer":"orderConfirmation_lottieContainer__oi1YX","lottie":"orderConfirmation_lottie__tH0FU","container":"orderConfirmation_container__2hOM1"};